import _ from 'underscore';
import React from 'react';
import { IconButton } from '@fluentui/react';
import { DefaultSortDirection } from './constants';
import { WithAutoResizeIcon } from '../autoResizeHeader';

function processSorted(sortedColumn, isSortedDescendingByDefault = true) {
  return (col) => {
    if (col.key && col.key === sortedColumn.key) {
      return {
        ...col,
        isSorted: true,
        isSortedDescending: sortedColumn.isSortedDescending,
      };
    }

    const { defaultSortDirection } = col;

    return {
      ...col,
      isSorted: false,
      isSortedDescending: defaultSortDirection ? defaultSortDirection === DefaultSortDirection.Ascending : isSortedDescendingByDefault,
    };
  };
}

function processSortable(handleSort) {
  return (col) => {
    if (col.sortable) {
      const originalOnClick = col.onColumnClick || _.noop;
      return {
        ...col,
        onColumnClick: (...args) => {
          originalOnClick(...args);
          handleSort(...args);
        },
      };
    }
    return col;
  };
}

function processInlineEdit(renderInlineEditPanel, dismissInlineEditPanel) {
  return col => ({
    ...col,
    onRender: (item, index, column) => {
      const onRender = col.onRender || (row => row[col.fieldName]);
      const { inlineEdit } = col;
      if ((typeof inlineEdit === 'boolean' && inlineEdit) || (typeof inlineEdit === 'function' && inlineEdit(item, index))) {
        return (
          <React.Fragment>
            <span className="campaign-details-list-cell-content">{onRender(item, index, column)}</span>
            <IconButton
              className="campaign-details-list-cell-edit"
              iconProps={{ iconName: 'Edit' }}
              title="Edit"
              ariaLabel="Edit"
              onClick={(e) => {
                if (typeof col.onInlineEditClick === 'function') {
                  col.onInlineEditClick(e, item, col);
                  return;
                }
                if (typeof col.onRenderInlineEdit === 'function') {
                  const cellEl = e.target.closest('.ms-DetailsRow-cell');
                  const selector = `.ms-List-cell[data-list-index="${index}"] .ms-DetailsRow-cell[aria-colindex="${cellEl.getAttribute('aria-colindex')}"]`;
                  renderInlineEditPanel(col.onRenderInlineEdit(e, item, dismissInlineEditPanel, cellEl.getBoundingClientRect(), selector));
                }
              }}
            />
          </React.Fragment>
        );
      }
      return onRender(item, index, column);
    },
  });
}

function processAutoResize(headerContainerRef) {
  return (col) => {
    if (!col.parentName) {
      const originalOnRenderHeader = col.onRenderHeader;
      return {
        ...col,
        onRenderHeader: props => (
          <WithAutoResizeIcon columnIndex={props.columnIndex - 1} containerRef={headerContainerRef}>{originalOnRenderHeader ? originalOnRenderHeader(props) : <>{col.name}</>}</WithAutoResizeIcon>
        ),
      };
    }
    return col;
  };
}

export function processColumns({
  columns, sortedColumn, handleSort, renderInlineEditPanel, dismissInlineEditPanel, isSortedDescendingByDefault, columnProcessors = [], headerContainerRef,
}) {
  if (!(columns instanceof Array)) {
    throw new Error('columns must be an array');
  }

  const processors = [
    processSorted(sortedColumn, isSortedDescendingByDefault),
    processSortable(handleSort),
    processInlineEdit(renderInlineEditPanel, dismissInlineEditPanel),
    processAutoResize(headerContainerRef),
  ];

  const processColumn = _.compose(...processors, ...columnProcessors);
  return columns.map(processColumn);
}

